export default __webpack_public_path__ + "static/media/clerk.c97c18ae.png";